import { useCallback, useEffect, useState } from "react";
import { RootState } from "../../store";
import { TextEnum } from "../../constants/text";
import { DataTable } from "../../constants/features/table";
import { PrivacyPolicyColumns } from "../../constants/features/columns";
import { MessageModal } from "../../constants/features/modal";
import { PrivacyPolicy } from "../../constants/entity";
import {
  useAppDispatch,
  useAppNavigate,
  useAppSelector,
  useDebounce,
} from "../../constants/global-hooks";
import {
  useHandleGetAllPrivacyPolicy,
  useHandlePrivacyPolicyAlertMessageChange,
  useHandlePrivacyPolicyPageChange,
} from "../../constants/utils";

import "./privacy-policy.scss";

export const PrivacyPolicyPage = () => {
  const dispatch = useAppDispatch();
  const navigate = useAppNavigate();
  const { privacyPolicies, pageCount, page, errorMessage } = useAppSelector(
    (state: RootState) => state.privacyPolicy,
  );
  const [searchTerm, setSearchTerm] = useState(false);

  const getPrivacyPolicies = useHandleGetAllPrivacyPolicy();
  const debouncedGetPrivacyPolicies = useDebounce(
    getPrivacyPolicies,
    searchTerm ? 500 : 0,
  );
  const handleAlertMessage =
    useHandlePrivacyPolicyAlertMessageChange(dispatch);

  const handleGetOne = useCallback(
    (record: PrivacyPolicy) => {
      navigate(`/privacy-policy/${record.id}`);
    },
    [navigate],
  );

  useEffect(() => {
    debouncedGetPrivacyPolicies();
  }, [debouncedGetPrivacyPolicies, page]);

  return (
    <main className="main-page">
      <div className="title">{TextEnum.PRIVACY_POLICY_PAGE_TITLE}</div>
      <div className="privacy-policy-buttons-container">
        <button
          className="create-privacy-policy-button"
          onClick={() => navigate("/privacy-policy/create")}
        >
          {TextEnum.NEW_PRIVACY_POLICY_VERSION}
        </button>
      </div>
      <DataTable
        dataSource={privacyPolicies}
        columns={Object.values(PrivacyPolicyColumns())}
        maxPage={pageCount}
        currentPage={page}
        setCurrentPage={useHandlePrivacyPolicyPageChange(
          dispatch,
          setSearchTerm,
        )}
        onRowClick={handleGetOne}
        functionDisabler={false}
        isAdminColumn={false}
        enableLastColumnClick={true}
      />
      {errorMessage && (
        <MessageModal
          title=""
          message={errorMessage}
          onCloseClick={handleAlertMessage}
        />
      )}
    </main>
  );
};
